"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PasswordProtection", {
  enumerable: true,
  get: function get() {
    return _PasswordProtection["default"];
  }
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _AttachmentIcon = _interopRequireDefault(require("../AttachmentIcon"));
var _Help = _interopRequireDefault(require("@material-ui/icons/Help"));
var _Tooltip = _interopRequireWildcard(require("../Tooltip"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Loop = _interopRequireDefault(require("@material-ui/icons/Loop"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _PriorityHigh = _interopRequireDefault(require("@material-ui/icons/PriorityHigh"));
var _Progress = _interopRequireDefault(require("./Progress"));
var _filesize = _interopRequireDefault(require("filesize"));
var _constants = require("../../utils/constants");
var _reactTransitionGroup = require("react-transition-group");
require("./index.css");
var _PasswordProtection = _interopRequireDefault(require("./PasswordProtection"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function hasAttachmentComplete(_ref) {
  var status = _ref.status,
    scanStatus = _ref.scanStatus;
  return status === _constants.largeAttachmentStatus.DONE && _constants.largeAttachmentScanStatus.SCANNING !== scanStatus;
}
var AttachmentBoxItem = function AttachmentBoxItem(_ref2) {
  var name = _ref2.name,
    size = _ref2.size,
    status = _ref2.status,
    contentType = _ref2.contentType,
    chunkSize = _ref2.chunkSize,
    _ref2$chunkLoaded = _ref2.chunkLoaded,
    chunkLoaded = _ref2$chunkLoaded === void 0 ? 0 : _ref2$chunkLoaded,
    uuid = _ref2.uuid,
    error = _ref2.error,
    parts = _ref2.parts,
    file = _ref2.file,
    scanStatus = _ref2.scanStatus,
    onRetry = _ref2.onRetry,
    onCancel = _ref2.onCancel,
    onClick = _ref2.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("flex items-center py-2 px-4", {
      'hover:bg-secondary': !!onClick
    }),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center justify-center w-8 h-8 rounded border"
  }, /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
    fontSize: "small",
    contentType: contentType,
    fileName: name,
    colored: true
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-40 pl-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs font-bold text-dark truncate",
    title: name
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs leading-tight text-gray-light"
  }, (0, _filesize["default"])(size))), !error ?
  // if file > 100MB no need to scan, so the scanstatus always DONE
  status !== _constants.largeAttachmentStatus.DONE || scanStatus === _constants.largeAttachmentScanStatus.SCANNING ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center flex-grow pl-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/_react["default"].createElement(_Progress["default"], {
    value: (chunkSize * parts.length + (chunkLoaded || 0)) / size * 100
  }))) : _constants.largeAttachmentScanStatus.INFECTED === scanStatus ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow text-right"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs font-semibold text-red"
  }, t('compose.upload.error.virusDetected'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-2"
  }, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
    className: "text-red"
  }))) : _constants.largeAttachmentScanStatus.BLOCKED === scanStatus ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow text-right"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs font-semibold text-red"
  }, t('compose.upload.error.failed'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-2"
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip.HelpTooltip, {
    title: t('compose.upload.error.blocked'),
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement(_Help["default"], {
    className: "text-red"
  })))) : _constants.INCOMPLETE_SCAN_STATUS.includes(scanStatus) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow text-right"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs font-semibold text-yellow"
  }, t('compose.upload.warning.scanningFailed'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-2"
  }, /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
    className: "text-primary"
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-2 flex-grow  inline-flex justify-end"
  }, /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
    className: "text-primary"
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow text-right"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onRetry(uuid);
    },
    className: "text-red rounded-full border border-red px-2 font-semibold text-xs hover:bg-secondary"
  }, t('button.retry'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-2"
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip.HelpTooltip, {
    title: error.message || t('compose.attachmentBox.upload.error')
  }, /*#__PURE__*/_react["default"].createElement(_Help["default"], {
    className: "text-red"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-2"
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: t('button.removeAttachment')
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    className: "cursor-pointer text-gray-medium hover:text-dark",
    style: {
      fontSize: 16
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      onCancel(uuid);
    }
  }))));
};
var AttachmentBox = function AttachmentBox(_ref3) {
  var _ref3$autoExpand = _ref3.autoExpand,
    autoExpand = _ref3$autoExpand === void 0 ? false : _ref3$autoExpand,
    _ref3$attachments = _ref3.attachments,
    attachments = _ref3$attachments === void 0 ? [] : _ref3$attachments,
    _ref3$passwordProtect = _ref3.passwordProtectionNode,
    passwordProtectionNode = _ref3$passwordProtect === void 0 ? null : _ref3$passwordProtect,
    _onRetry = _ref3.onRetry,
    _onCancel = _ref3.onCancel,
    onRetryAll = _ref3.onRetryAll,
    onClose = _ref3.onClose,
    onClick = _ref3.onClick;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var _useState = (0, _react.useState)(autoExpand && attachments.length <= 3),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    expanded = _useState2[0],
    setExpand = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isOpen = _useState4[0],
    setOpen = _useState4[1];
  var expandNodeRef = (0, _react.useRef)();
  var uploadError = (0, _react.useMemo)(function () {
    return attachments.some(function (item) {
      return item.error || _constants.INSECURE_SCAN_STATUS.includes(item.scanStatus);
    });
  }, [attachments]);
  var isShowRetryAll = (0, _react.useMemo)(function () {
    return attachments.some(function (item) {
      return item.error;
    });
  }, [attachments]);
  // const isAllcompleted = attachments.every(hasAttachmentComplete)

  var remainNumber = (0, _react.useMemo)(function () {
    return attachments.filter(function (item) {
      return !hasAttachmentComplete(item);
    }).length;
  }, [attachments]);
  (0, _react.useEffect)(function () {
    setOpen(true);
  }, [attachments.length]);

  // useEffect(() => {
  //   autoExpand && setExpand(expanded => {
  //     if (expanded) return expanded
  //     else return attachments.length <= 3
  //   })
  // }, [autoExpand, attachments.length])
  //auto expand when trigger error
  (0, _react.useEffect)(function () {
    if (uploadError) {
      setOpen(true);
      setExpand(true);
    }
  }, [uploadError]);
  (0, _react.useEffect)(function () {
    if (expanded && expandNodeRef.current) {
      expandNodeRef.current.scrollTop = 0;
    }
  }, [expanded, attachments.length]);
  if (!isOpen) return null;
  var expandNode = /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
    className: "attachment-box-list py-2 overflow-auto",
    style: {
      maxHeight: 160
    },
    ref: expandNodeRef
  }, attachments.map(function (attachment) {
    return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
      key: attachment.uuid,
      timeout: 500,
      classNames: "attachment-box-item"
    }, /*#__PURE__*/_react["default"].createElement(AttachmentBoxItem, (0, _extends2["default"])({}, attachment, {
      onRetry: function onRetry() {
        return _onRetry(attachment.uuid);
      },
      onCancel: function onCancel() {
        return _onCancel(attachment.uuid);
      },
      onClick: onClick ? function () {
        return onClick(attachment.uuid);
      } : null
    })));
  }));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixed bottom-0 right-0 bg-card shadow-lg overflow-auto",
    style: {
      width: 430,
      transform: 'translateX(-150px)',
      // the z-index is same with material dialog
      zIndex: 1300,
      maxHeight: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sticky top-0 bg-card z-10"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-gray-dark inline-flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('rounded-full w-6 h-6 inline-flex items-center justify-center mr-2', {
      'bg-primary': !uploadError,
      'bg-red': uploadError
    })
  }, uploadError ? /*#__PURE__*/_react["default"].createElement(_PriorityHigh["default"], {
    className: "text-white",
    fontSize: "small"
  }) : /*#__PURE__*/_react["default"].createElement(_Loop["default"], {
    fontSize: "small",
    className: (0, _classnames["default"])('text-white', {
      'icon-spin': remainNumber > 0
    })
  }), ' '), t('compose.attachmentBox.subject', {
    count: remainNumber
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    key: expanded,
    disableFocusListener: true,
    disableTouchListener: true,
    title: t(expanded ? 'button.unfold' : 'button.fold')
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disableRipple: true,
    size: "small",
    onClick: function onClick() {
      return setExpand(function (expanded) {
        return !expanded;
      });
    }
  }, expanded ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null))), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    disableFocusListener: true,
    disableTouchListener: true,
    title: t('button.close')
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disableRipple: true,
    size: "small",
    onClick: function onClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))))), uploadError ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm  font-semibold flex items-center justify-between my-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "  text-red"
  }, t(expanded ? 'compose.attachmentBox.uploadErrorExpand' : 'compose.attachmentBox.uploadError')), isShowRetryAll && /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-red rounded-full border border-red px-2 font-semibold text-xs hover:bg-secondary",
    onClick: onRetryAll
  }, t('button.retry'))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-sm"
  }, t(!!passwordProtectionNode ? 'compose.attachmentBox.tip2' : 'compose.attachmentBox.tip')), passwordProtectionNode)), expanded && /*#__PURE__*/_react["default"].createElement("hr", null)), expanded && expandNode);
};
var _default = exports["default"] = AttachmentBox;
//# sourceMappingURL=index.js.map